import { render, staticRenderFns } from "./MentionProvider.vue?vue&type=template&id=5e0c5b1c&"
import script from "./MentionProvider.vue?vue&type=script&lang=ts&"
export * from "./MentionProvider.vue?vue&type=script&lang=ts&"
import style0 from "./MentionProvider.vue?vue&type=style&index=0&id=5e0c5b1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports